import './styles.scss'

import React, { useEffect, useState } from 'react'
import { useActions, useValues } from 'kea'
import ReactHtmlParser from 'react-html-parser'

import redirect from 'lib/utils/redirect-url'
import I18n from 'lib/i18n'

import messageIcon from '../_assets/message-icon.svg'

import courseLogic from '~/scenes/course/show/logic'
import PropTypes from 'prop-types'
import Share from 'lib/icons/share'

import FavoriteButton from '~/scenes/course/show/favorite-button'
import displayProfileName from 'lib/utils/display-profile-name'

const LARGE_SCREEN_WIDTH = 1008
const MAX_CHARACTERS = 14

const BottomFloat = ({ onClick }) => {
  const { enableSharing } = useActions(courseLogic)
  const {
    windowWidth,
    course,
    needEmail,
    contactRedirect,
    isTablet,
    user: { firstName }
  } = useValues(courseLogic)

  const [isTabletBreakpoint, setIsTabletBreakpoint] = useState(false)

  const { messageUrl, messageUrlIsInbox } = course

  const shortenedFirstName = displayProfileName(firstName, MAX_CHARACTERS)

  useEffect(() => {
    if (window.innerWidth >= 600 && window.innerWidth < 1008) {
      setIsTabletBreakpoint(isTablet)
    } else {
      setIsTabletBreakpoint(false)
    }
  }, [isTablet])

  const handleMessageClick = () => {
    const shouldRedirectToMessageUrl = messageUrlIsInbox || windowWidth < LARGE_SCREEN_WIDTH

    if (needEmail) {
      redirect(contactRedirect)
    } else if (shouldRedirectToMessageUrl) {
      redirect(messageUrl)
    }
  }

  return (
    <div className='course-bottom-float'>
      <div className='good-fit-section'>
        <div className='good-fit-text'>
          <span>
            {ReactHtmlParser(
              isTabletBreakpoint
                ? I18n.t('courses.show_good_fit.first_lesson_backed')
                : I18n.t('courses.show_good_fit.first_lesson_backed_without_br')
            )}
          </span>
          {` `}
          <span className='underline' onClick={onClick}>
            {I18n.t('courses.show_good_fit.new_good_fit')}
          </span>
        </div>
        <div className='good-fit-icons'>
          <div>
            <Share onClick={enableSharing} />
          </div>
          <div>{course && <FavoriteButton />}</div>
        </div>
      </div>
      <div className='contact-teacher-button' onClick={handleMessageClick}>
        <div className='contact-teacher-icon'>
          <img className='message-icon' alt='message icon' src={messageIcon} width={24} height={24} />
        </div>
        <div className='contact-teacher-text'>
          {I18n.t('courses.show_contact.button', { first_name: shortenedFirstName })}
        </div>
      </div>
    </div>
  )
}

BottomFloat.propTypes = {
  onClick: PropTypes.func
}

export default BottomFloat
